<section>
  <div id="slider">
    <div id="headerSlider" class="carousel slide" data-ride="carousel">
      <!-- <ol class="carousel-indicators">
        <li data-target="#headerSlider" data-slide-to="0" class="active"></li>

      </ol> -->
      <div class="carousel-inner">
        <div class="carousel-item active">
          <img alt src="../assets/images/banner1.jpg" class="d-block w-100" />
          <div class="carousel-caption">
            <div class="banner-text">
              <!-- <h4 class="">Our Three Pillars</h4> -->
              <!-- <h5>STRIDE &middot; STRIVE &middot; SOAR</h5> -->
              <h2>Blog</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<div class="main">
  <div class="container">
    <div class="blog">
      <div class="row">
        <div class="leftcolumn">
          <div class="profile-header">
            <div class="profile-img">
              <img
                [src]="getImageUrl_profile(userDetail?.profilepicFilepath)"
                width="200"
              />
            </div>
            <div class="profile-nav-info">
              <h3 class="user-name">{{ userDetail?.full_name }}</h3>
              <p class="address">{{ userDetail?.position }}@</p>
              <span class="country">{{
                "Stride Real Estate " + userDetail?.city
              }}</span>
            </div>
          </div>

          <!-- <div class="card-follow">
            <h3>Follow Me</h3>
            <p>Some text..</p>
          </div> -->
        </div>
        <div class="rightcolumn">
          <div class="card-blogs">
            <div class="blog-img">
              <h2 class="blog-title">{{ blog?.title }}</h2>
              <p class="blog-date">{{ getDate(blog?.date) }}</p>
              <img
                alt
                [src]="getImageUrl(blog?.blogImagepath)"
                style="width: 100%"
              />
            </div>
          </div>
          <hr />
          <div innerHTML="{{ blog?.content }}"></div>
          <hr />
          <a class="btn btn-allblog" (click)="btnClick()">Back to all Blogs</a>
        </div>
      </div>
    </div>
  </div>
</div>
